// @ts-check
import { defineComponent } from 'vue';

/** @typedef {import('vue').VNode} VNode */

/**
 * Renderer component - exists to allow rendering content in a dynamic container
 * renders content with an optional render function
 */
export default defineComponent({
  functional: true,
  props: {
    /** @type {import('vue').PropOptions<object|string|number>} */
    content: { type: [Object, String, Number], required: true },
    /** @type {import('vue').PropOptions<(content: object|string|number) => VNode>} */
    render: { type: Function, required: false },
  },
  render(_, context) {
    const { render } = context.props;

    /** @type {string|number|VNode} content */
    // eslint-disable-next-line prefer-destructuring
    let content = context.props.content;
    if (typeof render === 'function') {
      content = render(content);
    }

    if (typeof content === 'string' || typeof content === 'number') {
      // @ts-ignore - vue doesn't declare the '_v' export
      // eslint-disable-next-line no-underscore-dangle
      return context._v(content);
    }

    return content;
  },
});
